module.exports = __webpack_public_path__ + "img/help_mh.1334c582.svg";